// extracted by mini-css-extract-plugin
export default {"clientInformation":"_3Jvy3___ClientInformation-module__clientInformation","clientLogo":"_1Skhi___ClientInformation-module__clientLogo"};